export default "__VITE_ASSET__bf86194f__"